import { ChartWidgetMetadata } from '@/modules/ta/legacy/widget/models/metadata/ChartWidgetMetadata';
import { BubbleChartDrawOption } from '@/modules/ta/legacy/widget/models/drawoptions/BubbleChartDrawOption';

export class BubbleChartWidgetMetadata extends ChartWidgetMetadata {
  constructor(model = {}) {
    super(model);

    this.draw_options = new BubbleChartDrawOption(model.draw_options);
  }
}
